module.exports = __webpack_public_path__ + "static/img/4.1de8f23c.png";